import { Multiselect } from '@tribeplatform/react-ui-kit/Multiselect'

import { useI18n } from '../../i18n/index.js'

interface MultiselectPickerProps {
  value: string[]
  options: string[]
  onChange: (newValues: string[]) => void
  className?: string
}
export const MultiselectPicker = ({
  value,
  options,
  onChange,
  className,
}: MultiselectPickerProps) => {
  const { $t } = useI18n()

  return (
    <Multiselect
      value={value}
      options={options}
      onChange={newValues => onChange(newValues)}
      className={className}
    >
      <Multiselect.Button
        placeholder={$t({
          defaultMessage: 'Select options',
          id: 'Filters.Values.Select.Placeholder',
        })}
        hideInput={value?.length > 0}
      >
        {value.map((option, index) => (
          <Multiselect.SelectedItem key={option} value={option} index={index}>
            {option}
          </Multiselect.SelectedItem>
        ))}
      </Multiselect.Button>
      <Multiselect.Items noWrapper>
        {options.map((option, index) => (
          <Multiselect.Item key={option} value={option} index={index}>
            {option}
          </Multiselect.Item>
        ))}
      </Multiselect.Items>
    </Multiselect>
  )
}
